export default function Git() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">Git</h1>
      Go_Parameters_and_Arguments
      <p className="mt-4 text-gray-500 text-sm">Path: /git</p>
    </div>
  );
}
